module.exports = __webpack_public_path__ + "static/media/dish11.cc1ce395.jpg";